// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import AccountForm from '../_common/AccountForm';
import Button from '../_common/form/Button';
import CheckBox from '../_common/form/CheckBox';
import Form from '../_common/form/Form';
import Input from '../_common/form/Input';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import MenuButton from '../_common/MenuButton';
import Modal from '../_common/Modal';
import HamLink from '../_common/form/HamLink';
import { handlePWReset } from '../_pwa/pages/LogIn';

const Error = styled.div`
    font-size: 0.7em;
    color: ${({ theme }) => theme.error};
`

const LogInButton = styled(Button)`
    ${({ nowrap }) => nowrap && 'white-space: nowrap;'}
`
const Row = styled.div`
    display: flex;
    justify-content: flex-end;
`
const ForgotPW = styled(HamLink)`
    font-size: 0.6em;
`

const LogIn = ({ children, ...props }) => {
    const {
        state: {
            active_user,
        },
        logIn,
        logOut
    } = useGlobalState();

    const getLogInForm = (errorText) => {
        return (
            <Form
                inputs={{
                    email: process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_ADMIN : '',
                    password: process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_PW : '',
                    rememberMe: false,
                }}
                onSubmit={(e) =>
                    logIn(e)
                        .then(() => Modal.Close())
                        .catch((e) => Modal.UpdateBody(getLogInForm(e.blob)))
                }
                submitButton='Sign In'
                submittingButton='Signing In'
            >
                <Row>
                    <ForgotPW onClick={handlePWReset}>Forgot Password?</ForgotPW>
                </Row>
                <Input
                    label='Email'
                    name='email'
                    required
                />
                <Input
                    label='Password'
                    name='password'
                    type='password'
                    required
                />
                <CheckBox
                    label='Remember Me?'
                    name='rememberMe'
                />
                <Error>{errorText}</Error>
            </Form>
        )
    }

    const handleLogInModal = () => {
        Modal.Show({
            title: 'Log In',
            body: getLogInForm(),
            buttons: <Button onClick={() => handleAccountCreation()}>Create An Account</Button>,
            icon: 'user'
        })
    }

    const handleLogOut = async () => {
        const logOutConfig = {
            title: 'Are you sure?',
            body: 'Are you sure you want to log out?',
            type: 'warning',
            closeAfter: true,
        }
        if (await Modal.Confirmation(logOutConfig)) logOut();
    }

    const handleAccountCreation = () => {
        Modal.Show({
            title: 'Account Creation',
            body: (
                <AccountForm
                    password
                    referral
                    signup
                    onAccountCreated={() => Modal.Close()}
                />
            ),
            icon: 'user'
        })
    }
    
    return (
        active_user.isLoggedIn ?
            <>
                <MenuButton to="/userManagement">
                    {active_user.account.firstName}
                </MenuButton>
                <LogInButton nowrap={props.nowrap} onClick={() => handleLogOut()}>
                    {children ?? 'Sign Out'}
                </LogInButton>
            </> :
            <LogInButton nowrap={props.nowrap} onClick={() => handleLogInModal()}>
                {children ?? 'Log In'}
            </LogInButton>
    );
}

export default LogIn;